
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import checkMarkIcon from '../../assets/images/icon-utility-check-mark.svg';

import './RewardsPoints.css';
import { Section } from '../../importCL';
    
interface IRewardsPointsProps extends MappedComponentProperties {
    title?: string;
    subtitle?: string;
    imagePath?: string;
    imageAltText?: string;
    benefits?: string[];
}

const MAX_BENEFITS = 6;

export const RewardsPointsEditConfig = {
    emptyLabel: 'Rewards Points',
    isEmpty: (props: PropsWithChildren<IRewardsPointsProps>) => {
        return !props || (!props.title && !props.subtitle && !props.imagePath && !props.benefits?.length);
    },
};

const RewardsPoints = (props: PropsWithChildren<IRewardsPointsProps>): JSX.Element => {
    const benefits = (props.benefits || [])
        .map((benefit) => benefit?.trim())
        .filter((benefit): benefit is string => Boolean(benefit))
        .slice(0, MAX_BENEFITS);

    return (
        <Section id='rewards-points' className='RewardsPoints flex flex-col items-start'>
            <div className='RewardsPoints__card flex border p-10 md:p-6'>
                <div className='RewardsPoints__content flex flex-col min-w-0 md:w-full'>
                    <div className='RewardsPoints__headingBlock md:mb-0'>
                        {props.title && <h2 className='RewardsPoints__title m-0'>{transformHTMLParserLinks(props.title)}</h2>}
                        {props.subtitle && <p className='RewardsPoints__subtitle'>{transformHTMLParserLinks(props.subtitle)}</p>}
                    </div>
                    {!!benefits.length && (
                        <ul className='RewardsPoints__benefits list-none grid m-0 p-0'>
                            {benefits.map((benefit, index) => (
                                <li key={`${benefit}-${index}`} className='RewardsPoints__benefit flex items-start mb-0'>
                                    <img className='RewardsPoints__benefitIcon' src={checkMarkIcon} alt='Checkmark' loading='lazy' decoding='async' fetchPriority='low'/>
                                    <span className='RewardsPoints__benefitText'>{transformHTMLParserLinks(benefit)}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                {props.imagePath && (
                    <div className='self-start'>
                        <img
                            className='RewardsPoints__image'
                            src={props.imagePath}
                            alt={props.imageAltText || ''}
                            loading='lazy'
                            decoding='async'
                            fetchPriority='low'
                        />
                    </div>
                )}
            </div>
        </Section>
    );
};

export default RewardsPoints;
        
